module.exports = __webpack_public_path__ + "img/not_found (5).af551a65.jpg";